import React from 'react';
import BaseRateActiveRates from '../../components/BaseRates/BaseRateActiveRates';
import { connect } from 'react-redux';
import { getRateSheet, getTerminals, updateRateSheet } from '../Dashboard/DashboardActions';
import { setTerminal, setBaseRateUi  } from './BaseRatesUiActions';

class BaseRateActiveRatesContainer extends React.Component {
  
  componentDidMount() {
    const {getTerminals} = this.props;
    getTerminals();
  }

  render(){
    let { setTerminalId, importSheet, updateRateSheet, uiState, rateSheet, dispatchSetUiState, dispatchGetRateSheet, terminals, terminalObject } = this.props;
    terminals = terminals.get('data') || [];

    return <BaseRateActiveRates
    uiState={uiState}
    terminalObject={terminalObject}
    terminals={terminals}
    rateSheet={rateSheet}
    importSheet={importSheet}
    dispatchGetRateSheet={dispatchGetRateSheet}
    updateRateSheet={updateRateSheet}
    setTerminalId={setTerminalId}
    dispatchSetUiState={dispatchSetUiState}
    />;
  }
}


const mapStateToProps = (state) => {
  return {
    rateSheet: state.business.rateSheet,
    importSheet: state.business.importSheet ,
    terminals: state.business.terminals,
    uiState: state.baseRateUi.baseRateUi.toObject()
  };
};

const mapDisptatchToProps = (dispatch) => ({
  dispatchGetRateSheet: (parameters, callback) => dispatch(getRateSheet(parameters, callback)),
  getTerminals: () => dispatch(getTerminals()),
  updateRateSheet: (parameters, callback) => dispatch(updateRateSheet(parameters, callback)),
  setTerminalId: terminalId => dispatch(setTerminal(terminalId)),
  dispatchSetUiState: state => dispatch(setBaseRateUi(state))
});


export default connect(mapStateToProps, mapDisptatchToProps)(BaseRateActiveRatesContainer);


// WEBPACK FOOTER //
// ./src/containers/BaseRates/BaseRateActiveRatesContainer.js